import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FormControl } from "@mui/material";

import MDBox from "theme/components/MDBox";
import Multiselect from "multiselect-react-dropdown";
import MDTypography from "components/MDTypography";

function MultiSelectField({ displayName, fieldRef, isOptional, options }) {
  const [selectedChoices, setSelectedChoices] = useState(new Set());
  const [ccs, setCCs] = useState(null);
  const [mchoices, setMChoices] = useState([]);

  useEffect(() => {
    if (selectedChoices.size <= 0) {
      setCCs(null);
      return;
    }

    const lls = [];
    selectedChoices.forEach((opt) => {
      lls.push(opt);
    });

    // setCCs(JSON.stringify(lls));
    setCCs(lls.join());
  }, [selectedChoices]);

  useEffect(() => {
    const xArr = [];
    selectedChoices.forEach((item) => {
      options.every((ele) => {
        if (ele.value === item) {
          xArr.push(ele);
          return false;
        }
        return true;
      });
    });
    setMChoices(xArr);
  }, [selectedChoices]);

  return (
    <MDBox mt={0}>
      <MDBox ml={0.5}>
        <MDTypography variant="h6" fontSize={14} fontWeight="light">
          {displayName}
        </MDTypography>
      </MDBox>
      <MDBox mt={0.5}>
        <FormControl sx={{ minWidth: 120, width: "100%" }}>
          <Multiselect
            options={options} // Options to display in the dropdown
            selectedValues={mchoices} // Preselected value to persist in dropdown
            onSelect={(selectedList, selectedItem) => {
              const newSet = new Set(selectedChoices);
              if (!newSet.has(selectedItem.value)) {
                newSet.add(selectedItem.value);
                setSelectedChoices(newSet);
              }
            }} // Function will trigger on select event
            onRemove={(selectedList, removedItem) => {
              const newSet = new Set(selectedChoices);
              if (newSet.has(removedItem.value)) {
                newSet.delete(removedItem.value);
                setSelectedChoices(newSet);
              }
            }} // Function will trigger on remove event
            displayValue="name" // Property name to display in the dropdown options
            showCheckbox={false}
            // placeholder={displayName}
            avoidHighlightFirstOption
            color="primary"
          />
        </FormControl>
        <input
          type="hidden"
          id={`dff_${fieldRef}`}
          name={fieldRef}
          value={ccs}
        />
      </MDBox>
    </MDBox>
  );
}

// Typechecking props of the Transaction
MultiSelectField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

MultiSelectField.defaultProps = {
  options: null,
};
export default MultiSelectField;
